/**
 * Icon Size
 */
export var IconSize;
(function (IconSize) {
    IconSize["SMALL"] = "small";
    IconSize["MEDIUM"] = "medium";
    IconSize["LARGE"] = "large";
    IconSize["HUGE"] = "huge";
    IconSize["SMALLER"] = "smaller";
})(IconSize || (IconSize = {}));
/**
 * Icon Status
 */
export var IconStatus;
(function (IconStatus) {
    IconStatus["SUCCESS"] = "SUCCESS";
    IconStatus["ERROR"] = "ERROR";
    IconStatus["WARNING"] = "WARNING";
    IconStatus["INFO"] = "INFO";
    IconStatus["WHITE"] = "WHITE";
})(IconStatus || (IconStatus = {}));
/**
 * Icon Color
 */
export var IconColor;
(function (IconColor) {
    IconColor["SUCCESS"] = "SUCCESS";
    IconColor["ERROR"] = "ERROR";
    IconColor["INFO"] = "INFO";
    IconColor["WARNING"] = "WARNING";
    IconColor["MAIN"] = "MAIN";
    IconColor["BACKGROUND"] = "BACKGROUND";
    IconColor["ACCENT"] = "ACCENT";
    IconColor["NEUTRAL"] = "NEUTRAL";
    IconColor["WHITE"] = "WHITE";
    IconColor["GREY"] = "NEUTRAL";
})(IconColor || (IconColor = {}));
/**
 * Text Icon Direction
 */
export var IconPosition;
(function (IconPosition) {
    IconPosition["UP"] = "up";
    IconPosition["DOWN"] = "down";
    IconPosition["LEFT"] = "left";
    IconPosition["RIGHT"] = "right";
})(IconPosition || (IconPosition = {}));
export var TextIconMarkup;
(function (TextIconMarkup) {
    TextIconMarkup["DIV"] = "div";
    TextIconMarkup["A"] = "a";
    TextIconMarkup["P"] = "p";
    TextIconMarkup["SPAN"] = "span";
})(TextIconMarkup || (TextIconMarkup = {}));
export var IconStatusPosition;
(function (IconStatusPosition) {
    IconStatusPosition["TOP"] = "top";
    IconStatusPosition["BOTTOM"] = "bottom";
})(IconStatusPosition || (IconStatusPosition = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSWNvbkVudW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9jb21wb25lbnRzL2ljb24vSWNvbkVudW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLENBQU4sSUFBWSxRQU1YO0FBTkQsV0FBWSxRQUFRO0lBQ2xCLDJCQUFlLENBQUE7SUFDZiw2QkFBaUIsQ0FBQTtJQUNqQiwyQkFBZSxDQUFBO0lBQ2YseUJBQWEsQ0FBQTtJQUNiLCtCQUFtQixDQUFBO0FBQ3JCLENBQUMsRUFOVyxRQUFRLEtBQVIsUUFBUSxRQU1uQjtBQU9EOztHQUVHO0FBQ0gsTUFBTSxDQUFOLElBQVksVUFNWDtBQU5ELFdBQVksVUFBVTtJQUNwQixpQ0FBbUIsQ0FBQTtJQUNuQiw2QkFBZSxDQUFBO0lBQ2YsaUNBQW1CLENBQUE7SUFDbkIsMkJBQWEsQ0FBQTtJQUNiLDZCQUFlLENBQUE7QUFDakIsQ0FBQyxFQU5XLFVBQVUsS0FBVixVQUFVLFFBTXJCO0FBT0Q7O0dBRUc7QUFDSCxNQUFNLENBQU4sSUFBWSxTQVdYO0FBWEQsV0FBWSxTQUFTO0lBQ25CLGdDQUFtQixDQUFBO0lBQ25CLDRCQUFlLENBQUE7SUFDZiwwQkFBYSxDQUFBO0lBQ2IsZ0NBQW1CLENBQUE7SUFDbkIsMEJBQWEsQ0FBQTtJQUNiLHNDQUF5QixDQUFBO0lBQ3pCLDhCQUFpQixDQUFBO0lBQ2pCLGdDQUFtQixDQUFBO0lBQ25CLDRCQUFlLENBQUE7SUFDZiw2QkFBZ0IsQ0FBQTtBQUNsQixDQUFDLEVBWFcsU0FBUyxLQUFULFNBQVMsUUFXcEI7QUFPRDs7R0FFRztBQUVILE1BQU0sQ0FBTixJQUFZLFlBS1g7QUFMRCxXQUFZLFlBQVk7SUFDdEIseUJBQVMsQ0FBQTtJQUNULDZCQUFhLENBQUE7SUFDYiw2QkFBYSxDQUFBO0lBQ2IsK0JBQWUsQ0FBQTtBQUNqQixDQUFDLEVBTFcsWUFBWSxLQUFaLFlBQVksUUFLdkI7QUFPRCxNQUFNLENBQU4sSUFBWSxjQUtYO0FBTEQsV0FBWSxjQUFjO0lBQ3hCLDZCQUFXLENBQUE7SUFDWCx5QkFBTyxDQUFBO0lBQ1AseUJBQU8sQ0FBQTtJQUNQLCtCQUFhLENBQUE7QUFDZixDQUFDLEVBTFcsY0FBYyxLQUFkLGNBQWMsUUFLekI7QUFJRCxNQUFNLENBQU4sSUFBWSxrQkFHWDtBQUhELFdBQVksa0JBQWtCO0lBQzVCLGlDQUFXLENBQUE7SUFDWCx1Q0FBaUIsQ0FBQTtBQUNuQixDQUFDLEVBSFcsa0JBQWtCLEtBQWxCLGtCQUFrQixRQUc3QiJ9